import React from 'react';
import { HealthPlan } from '../../../../graphql/graphql';
import BaseModal from '../../../Base/Components/BaseModal/BaseModal';
import WorkplaceHealthPlanEditForm from './WorkplaceHealthPlanEditForm';

interface Props {
	item: HealthPlan;
	onClose: () => void;
	onSuccess: () => void;
}

const WorkplaceHealthPlanEdit = ({ item, onClose, onSuccess }: Props) => {
	return (
		<BaseModal
			title={'component.healthPlan.editSettings'}
			isOpen={true}
			onClose={onClose}>
			<WorkplaceHealthPlanEditForm
				healthPlanId={item.id}
				onSuccess={onSuccess}
			/>
		</BaseModal>
	);
};

export default WorkplaceHealthPlanEdit;
